import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";

export const useRefetchCandidacyComments = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ candidacyId }: { candidacyId: string }) => {
    void queryClient.refetchQueries({
      queryKey: [
        "candidacy_comments",
        currentCompanyId,
        currentJobId,
        candidacyId,
      ],
    });
  };
};
